<div *ngIf="visible && operation && damage" class="popup-overlay" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <div class="popup-header-title">
        <span class="popup-title-icon" [ngClass]="'popup-title-icon--' + meta.tone">
          <i class="fas" [ngClass]="meta.icon"></i>
        </span>
        <div class="popup-title-text">
          <h4 class="popup-title">{{ meta.title }}</h4>
          <p class="popup-subtitle">{{ meta.subtitle }}</p>
        </div>
      </div>
      <button type="button" class="btn-close" (click)="close()" title="Chiudi">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <!-- Contesto della pratica: codice, collo, stato e assegnatario correnti -->
      <div class="op-context">
        <span class="op-chip op-chip--code"><i class="fas fa-folder-open"></i>{{ damageLabel }}</span>
        <span class="op-chip" *ngIf="damage.damageParcelCode"><i class="fas fa-box"></i>{{ damage.damageParcelCode }}</span>
        <span class="op-chip"><i class="fas fa-flag"></i>{{ currentStatus || '-' }}</span>
        <span class="op-chip" *ngIf="currentAssigneeName"><i class="fas fa-user"></i>{{ currentAssigneeName }}</span>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()" [ngSwitch]="operation">

        <!-- ─── Cambio stato ─── -->
        <div class="form-section" *ngSwitchCase="'status'">
          <div class="section-title"><i class="fas fa-exchange-alt"></i> Nuovo stato</div>
          <div class="row g-3">
            <div class="col-12">
              <label for="opStatus" class="form-label">Stato*</label>
              <select id="opStatus" class="form-select" formControlName="status" [ngClass]="{'is-invalid': isInvalid('status')}">
                <option value="" disabled>Seleziona lo stato...</option>
                <option *ngFor="let s of availableWorkStatuses" [value]="s.value">{{ s.label }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('status')">Lo stato è obbligatorio</small>
            </div>
            <div class="col-12">
              <label for="opStatusNote" class="form-label">Nota</label>
              <input type="text" id="opStatusNote" class="form-control op-input--tall" maxlength="2000" autocomplete="off"
                     formControlName="note" placeholder="Nota facoltativa registrata sull'evento">
            </div>
          </div>
          <small class="field-hint">Per chiudere o respingere la pratica usa "Chiusura pratica".</small>
        </div>

        <!-- ─── Classificazione: tipo danno, gravità, priorità ─── -->
        <div class="form-section" *ngSwitchCase="'classification'">
          <div class="section-title"><i class="fas fa-layer-group"></i> Classificazione</div>
          <div class="row g-3">
            <div class="col-md-5">
              <label for="opClassType" class="form-label">Tipo danno*</label>
              <select id="opClassType" class="form-select" formControlName="type" [ngClass]="{'is-invalid': isInvalid('type')}">
                <option value="" disabled>Seleziona il tipo...</option>
                <option *ngFor="let t of availableTypes" [value]="t">{{ 'DAMAGES.TYPE.' + t | translate }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('type')">Il tipo è obbligatorio</small>
            </div>
            <div class="col-md-4">
              <label for="opClassSeverity" class="form-label">Gravità*</label>
              <select id="opClassSeverity" class="form-select" formControlName="severity" [ngClass]="{'is-invalid': isInvalid('severity')}">
                <option value="" disabled>Seleziona la gravità...</option>
                <option *ngFor="let s of severityOptions" [value]="s">{{ 'DAMAGES.SEVERITY.' + s | translate }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('severity')">La gravità è obbligatoria</small>
            </div>
            <div class="col-md-3">
              <label for="opClassPriority" class="form-label">Priorità*</label>
              <select id="opClassPriority" class="form-select" formControlName="priority" [ngClass]="{'is-invalid': isInvalid('priority')}">
                <option [ngValue]="null" disabled>Seleziona...</option>
                <option *ngFor="let p of priorityOptions" [ngValue]="p">{{ p }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('priority')">La priorità è obbligatoria</small>
            </div>
            <div class="col-12">
              <label for="opClassNote" class="form-label">Nota</label>
              <input type="text" id="opClassNote" class="form-control op-input--tall" maxlength="2000" autocomplete="off"
                     formControlName="note" placeholder="Motivo della modifica (facoltativo), registrato sull'evento">
            </div>
          </div>
          <small class="field-hint" *ngIf="hasClassificationChanges">Le modifiche vengono registrate nella cronologia con il valore precedente e quello nuovo.</small>
          <small class="field-hint" *ngIf="!hasClassificationChanges">Modifica almeno un valore per salvare. Per lo stato usa "Cambio stato".</small>
        </div>

        <!-- ─── Assegnazione ─── -->
        <div class="form-section" *ngSwitchCase="'assign'">
          <div class="section-title"><i class="fas fa-user-check"></i> Assegnatario</div>
          <div class="row g-3">
            <div class="col-12">
              <div class="detail-label">Attualmente assegnata a</div>
              <div class="detail-value">{{ currentAssigneeName || 'Nessuno' }}</div>
            </div>
            <div class="col-12">
              <label for="opAssignee" class="form-label">{{ currentAssigneeName ? 'Nuovo assegnatario (codice utente)*' : 'Assegnatario (codice utente)*' }}</label>
              <input type="text" id="opAssignee" class="form-control op-input--tall" maxlength="50" autocomplete="off"
                     formControlName="assignedTo" placeholder="Codice utente dell'operatore"
                     [ngClass]="{'is-invalid': isInvalid('assignedTo')}">
              <small class="field-error" *ngIf="isInvalid('assignedTo')">Il codice utente è obbligatorio</small>
            </div>
          </div>
          <small class="field-hint">L'assegnazione viene registrata nella cronologia della pratica.</small>
        </div>

        <!-- ─── Nota ─── -->
        <div class="form-section" *ngSwitchCase="'note'">
          <div class="section-title"><i class="fas fa-sticky-note"></i> Testo della nota</div>
          <textarea class="form-control op-textarea--tall" rows="6" maxlength="2000" formControlName="note"
                    placeholder="Nota da registrare in cronologia"
                    [ngClass]="{'is-invalid': isInvalid('note')}"></textarea>
          <small class="field-error" *ngIf="isInvalid('note')">Il testo della nota è obbligatorio</small>
        </div>

        <!-- ─── Nuovo importo ─── -->
        <div class="form-section" *ngSwitchCase="'amount'">
          <div class="section-title"><i class="fas fa-euro-sign"></i> Importo</div>
          <div class="row g-3">
            <div class="col-md-5">
              <label for="opAmountType" class="form-label">Tipo*</label>
              <select id="opAmountType" class="form-select" formControlName="type" [ngClass]="{'is-invalid': isInvalid('type')}">
                <option value="" disabled>Seleziona il tipo...</option>
                <option *ngFor="let t of amountTypeOptions" [value]="t.value">{{ t.label }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('type')">Il tipo è obbligatorio</small>
            </div>
            <div class="col-md-4">
              <label for="opAmountValue" class="form-label">Valore*</label>
              <input type="text" id="opAmountValue" class="form-control text-end" inputmode="decimal" autocomplete="off"
                     formControlName="value" placeholder="0,00" (input)="onValueInput($event)"
                     [ngClass]="{'is-invalid': isInvalid('value')}">
              <small class="field-error" *ngIf="isInvalid('value')">Indica un valore maggiore di zero</small>
            </div>
            <div class="col-md-3">
              <label for="opAmountCurrency" class="form-label">Valuta*</label>
              <input type="text" id="opAmountCurrency" class="form-control text-uppercase" maxlength="3" autocomplete="off"
                     formControlName="currency" placeholder="EUR" [ngClass]="{'is-invalid': isInvalid('currency')}">
              <small class="field-error" *ngIf="isInvalid('currency')">Codice valuta di 3 lettere</small>
            </div>
            <div class="col-md-7">
              <label for="opCounterpart" class="form-label">Controparte</label>
              <input type="text" id="opCounterpart" class="form-control" maxlength="200" autocomplete="off"
                     formControlName="counterpart" placeholder="Es. corriere, cliente, dealer">
            </div>
            <div class="col-md-5">
              <label for="opCounterpartCode" class="form-label">Codice controparte</label>
              <input type="text" id="opCounterpartCode" class="form-control" maxlength="50" autocomplete="off"
                     formControlName="counterpartCode" placeholder="Codice">
            </div>
            <div class="col-12">
              <label for="opAmountNote" class="form-label">Nota</label>
              <input type="text" id="opAmountNote" class="form-control" maxlength="2000" autocomplete="off"
                     formControlName="note" placeholder="Nota facoltativa">
            </div>
          </div>
          <small class="field-hint">L'importo viene registrato con stato PROPOSED e compare tra gli importi della pratica.</small>
        </div>

        <!-- ─── Stato importo ─── -->
        <div class="form-section" *ngSwitchCase="'amountStatus'">
          <div class="section-title"><i class="fas fa-file-invoice-dollar"></i> Importo da aggiornare</div>
          <div class="row g-3">
            <div class="col-12">
              <label for="opAmountId" class="form-label">Importo*</label>
              <select id="opAmountId" class="form-select" formControlName="amountId" [ngClass]="{'is-invalid': isInvalid('amountId')}">
                <option [ngValue]="null" disabled>Seleziona l'importo...</option>
                <option *ngFor="let a of amounts; trackBy: trackByAmount" [ngValue]="a.damageAmountId">{{ amountOptionLabel(a) }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('amountId')">Seleziona un importo</small>
            </div>
            <div class="col-md-7">
              <label for="opAmountStatus" class="form-label">Nuovo stato*</label>
              <select id="opAmountStatus" class="form-select" formControlName="status" [ngClass]="{'is-invalid': isInvalid('status')}">
                <option value="" disabled>Seleziona lo stato...</option>
                <option *ngFor="let s of amountStatusOptions" [value]="s">{{ 'DAMAGES.STATUS.' + s | translate }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('status')">Lo stato è obbligatorio</small>
            </div>
            <div class="col-md-5">
              <label for="opChargeId" class="form-label">Id addebito</label>
              <input type="text" id="opChargeId" class="form-control" inputmode="numeric" autocomplete="off"
                     formControlName="chargeId" placeholder="Facoltativo" [ngClass]="{'is-invalid': isInvalid('chargeId')}">
              <small class="field-error" *ngIf="isInvalid('chargeId')">Deve essere un numero intero</small>
            </div>
          </div>
        </div>

        <!-- ─── Modifica importo ─── -->
        <div class="form-section" *ngSwitchCase="'amountEdit'">
          <div class="section-title"><i class="fas fa-pen"></i> Importo da modificare</div>
          <div class="row g-3">
            <div class="col-12">
              <div class="detail-label">Importo</div>
              <div class="detail-value">{{ amountLabel || '-' }}</div>
            </div>
            <div class="col-md-5">
              <label for="opEditType" class="form-label">Tipo*</label>
              <select id="opEditType" class="form-select" formControlName="type" [ngClass]="{'is-invalid': isInvalid('type')}">
                <option value="" disabled>Seleziona il tipo...</option>
                <option *ngFor="let t of amountTypeOptions" [value]="t.value">{{ t.label }}</option>
                <option *ngIf="amount?.damageAmountType && !amountTypeOptionValues.includes(amount!.damageAmountType!)" [value]="amount!.damageAmountType">{{ amount!.damageAmountType }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('type')">Il tipo è obbligatorio</small>
            </div>
            <div class="col-md-4">
              <label for="opEditValue" class="form-label">Valore*</label>
              <input type="text" id="opEditValue" class="form-control text-end" inputmode="decimal" autocomplete="off"
                     formControlName="value" placeholder="0,00" (input)="onValueInput($event)"
                     [ngClass]="{'is-invalid': isInvalid('value')}">
              <small class="field-error" *ngIf="isInvalid('value')">Indica un valore maggiore di zero</small>
            </div>
            <div class="col-md-3">
              <label for="opEditCurrency" class="form-label">Valuta*</label>
              <input type="text" id="opEditCurrency" class="form-control text-uppercase" maxlength="3" autocomplete="off"
                     formControlName="currency" placeholder="EUR" [ngClass]="{'is-invalid': isInvalid('currency')}">
              <small class="field-error" *ngIf="isInvalid('currency')">Codice valuta di 3 lettere</small>
            </div>
            <div class="col-md-7">
              <label for="opEditCounterpart" class="form-label">Controparte</label>
              <input type="text" id="opEditCounterpart" class="form-control" maxlength="200" autocomplete="off"
                     formControlName="counterpart" placeholder="Es. corriere, cliente, dealer">
            </div>
            <div class="col-md-5">
              <label for="opEditCounterpartCode" class="form-label">Codice controparte</label>
              <input type="text" id="opEditCounterpartCode" class="form-control" maxlength="50" autocomplete="off"
                     formControlName="counterpartCode" placeholder="Codice">
            </div>
            <div class="col-12">
              <label for="opEditAmountNote" class="form-label">Nota dell'importo</label>
              <input type="text" id="opEditAmountNote" class="form-control" maxlength="2000" autocomplete="off"
                     formControlName="amountNote" placeholder="Nota facoltativa sull'importo">
            </div>
            <div class="col-md-7">
              <label for="opEditStatus" class="form-label">Stato*</label>
              <select id="opEditStatus" class="form-select" formControlName="status" [ngClass]="{'is-invalid': isInvalid('status')}">
                <option value="" disabled>Seleziona lo stato...</option>
                <option *ngFor="let s of amountStatusOptions" [value]="s">{{ 'DAMAGES.STATUS.' + s | translate }}</option>
                <option *ngIf="amount?.damageAmountStatus && !amountStatusOptions.includes(amount!.damageAmountStatus!)" [value]="amount!.damageAmountStatus">{{ amount!.damageAmountStatus }}</option>
              </select>
              <small class="field-error" *ngIf="isInvalid('status')">Lo stato è obbligatorio</small>
            </div>
            <div class="col-md-5">
              <label for="opEditChargeId" class="form-label">Id addebito</label>
              <input type="text" id="opEditChargeId" class="form-control" inputmode="numeric" autocomplete="off"
                     formControlName="chargeId" placeholder="Facoltativo" [ngClass]="{'is-invalid': isInvalid('chargeId')}">
              <small class="field-error" *ngIf="isInvalid('chargeId')">Deve essere un numero intero</small>
            </div>
            <div class="col-12">
              <label for="opEditReason" class="form-label">Motivo della modifica</label>
              <input type="text" id="opEditReason" class="form-control" maxlength="2000" autocomplete="off"
                     formControlName="note" placeholder="Facoltativo, registrato sull'evento in cronologia">
            </div>
          </div>
          <small class="field-hint" *ngIf="hasAmountChanges">Le modifiche vengono registrate nella cronologia con il valore precedente e quello nuovo; il cambio di stato come evento separato.</small>
          <small class="field-hint" *ngIf="!hasAmountChanges">Modifica almeno un valore per salvare.</small>
        </div>

        <!-- ─── Elimina importo ─── -->
        <div class="form-section form-section--danger" *ngSwitchCase="'amountDelete'">
          <div class="section-title"><i class="fas fa-trash-alt"></i> Eliminazione definitiva</div>
          <div class="row g-3">
            <div class="col-12">
              <div class="detail-label">Importo</div>
              <div class="detail-value">{{ amountLabel || '-' }}</div>
            </div>
            <div class="col-12">
              <label for="opDeleteNote" class="form-label">Motivo</label>
              <textarea id="opDeleteNote" class="form-control" rows="3" maxlength="2000" formControlName="note"
                        placeholder="Motivo facoltativo, registrato sull'evento in cronologia"></textarea>
            </div>
            <div class="col-12">
              <label class="op-confirm" [class.op-confirm--invalid]="isInvalid('confirm')">
                <input type="checkbox" class="form-check-input" formControlName="confirm">
                <span>
                  Confermo l'eliminazione dell'importo <strong>#{{ amount?.damageAmountId }}</strong> dalla pratica <strong>{{ damageLabel }}</strong>.
                  L'importo non sarà recuperabile; i suoi dati restano nell'evento di cronologia.
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- ─── Chiusura ─── -->
        <div class="form-section form-section--danger" *ngSwitchCase="'close'">
          <div class="section-title"><i class="fas fa-flag-checkered"></i> Chiusura definitiva</div>
          <div class="row g-3">
            <div class="col-md-6">
              <label for="opCloseStatus" class="form-label">Stato di chiusura*</label>
              <select id="opCloseStatus" class="form-select" formControlName="status">
                <option *ngFor="let s of closeStatusOptions" [value]="s.value">{{ s.label }}</option>
              </select>
            </div>
            <div class="col-md-6">
              <label for="opCloseOutcome" class="form-label">Esito</label>
              <select id="opCloseOutcome" class="form-select" formControlName="outcome">
                <option value="">Nessun esito</option>
                <option *ngFor="let o of closeOutcomeOptions" [value]="o">{{ o }}</option>
              </select>
            </div>
            <div class="col-12">
              <label for="opCloseNote" class="form-label">Nota di chiusura</label>
              <textarea id="opCloseNote" class="form-control" rows="3" maxlength="2000" formControlName="note"
                        placeholder="Nota facoltativa"></textarea>
            </div>
            <div class="col-12">
              <label class="op-confirm" [class.op-confirm--invalid]="isInvalid('confirm')">
                <input type="checkbox" class="form-check-input" formControlName="confirm">
                <span>
                  Confermo la chiusura della pratica <strong>{{ damageLabel }}</strong> come <strong>{{ closeStatusLabel }}</strong>.
                  Dopo la chiusura non potrà più cambiare stato né essere riassegnata.
                </span>
              </label>
            </div>
          </div>
        </div>

      </form>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="close()" [disabled]="isSubmitting">Annulla</button>
      <button type="button" class="btn" [ngClass]="meta.danger ? 'btn-danger' : 'btn-primary'" (click)="submit()" [disabled]="!canSubmit">
        <i class="fas me-1" [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : meta.submitIcon"></i>{{ meta.submitLabel }}
      </button>
    </div>

  </div>
</div>
